import { Injectable, resource } from '@angular/core';
import { RestDatasource } from '@core/api/rest.datasource';
import { Organisation } from '@features/organisation/organisation.model';

@Injectable({
  providedIn: 'root'
})
export class OrganisationDatasource extends RestDatasource<Organisation> {

  override endpoint='/v2/organisationer';

  data = resource({
    loader: async ({ abortSignal }) => {
      return await this.getList({
        sortBy: 'navn'
      }, abortSignal);
    }
  });

}
